/**
 * Daily localStorage snapshot of the measure-deals list.
 * On successful fetch the result is saved; on network failure / offline,
 * the last snapshot is returned so the wizard's deal selector works without internet.
 */

const KEY = "tpt-measure-deals-snapshot";

interface Snapshot {
  calendarDate: string;
  savedAt: string;
  data: { label: string; deals: any[] }[];
}

function todayDate(): string {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

export function saveMeasureDealsSnapshot(data: { label: string; deals: any[] }[]): void {
  try {
    const snapshot: Snapshot = {
      calendarDate: todayDate(),
      savedAt: new Date().toISOString(),
      data,
    };
    localStorage.setItem(KEY, JSON.stringify(snapshot));
  } catch {
    /* quota or private mode */
  }
}

export function loadMeasureDealsSnapshot(): { data: { label: string; deals: any[] }[]; stale: boolean } | null {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const snapshot: Snapshot = JSON.parse(raw);
    if (!Array.isArray(snapshot.data)) return null;
    const stale = snapshot.calendarDate !== todayDate();
    return { data: snapshot.data, stale };
  } catch {
    return null;
  }
}
